import React from "react";
import { Navigate } from "react-router-dom";
import { PAGES_ENDPOINTS } from "../constants/Endpoints";
import { useUserInfo } from "../providers/UserProvider";
import {USER_ROLES} from "../constants/Roles";

const PrivateRoute = ({ children, isAdminRoute = false }) => {
  const { isAuthenticated, userInfo } = useUserInfo();
  const impersonatedUserId = localStorage.getItem("impersonatedUserId");

  if (userInfo?.user.role === USER_ROLES.SOFTWARE_DEV && impersonatedUserId === null && !isAdminRoute) {
    return <Navigate to={PAGES_ENDPOINTS.ADMIN} />;
  }
  return isAuthenticated ? children : <Navigate to={PAGES_ENDPOINTS.LOGIN} />;
};

export default PrivateRoute;
